export default (str) => str.split('/').slice(-1).join('')
